import { Handshake, UserRound } from 'lucide-react'
import React from 'react'
import { useState, useEffect } from 'react'
import bgimage1 from '../../Assest/bgimage1.avif'
import bgimage2 from '../../Assest/bgimage2.avif'
import bgimage3 from '../../Assest/bgimage3.avif'
import HireTalent from './HireTalent'

export default function Home() {
    const images = [bgimage1, bgimage2, bgimage3]
    const [currentimage, setCurrentImage] = useState(0)
    const [hireopen, setHireopen] = useState(false)
    const [fromtype, setFromtype] = useState();

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentImage(prev => (prev + 1) % images.length)
        }, 4000);
        return () => clearInterval(interval)
    }, [images.length])

    const handlerhire = (value) => {
        setHireopen(prev => !prev)
        setFromtype(value)
    }

    return (
        <section
            id='home'
            className='relative w-full h-screen min-h-[600px] bg-cover bg-center bg-no-repeat overflow-hidden'
            style={{ backgroundImage: `url(${images[currentimage]})` }}
        >
            {/* Overlay for better text readability */}
            <div className="absolute inset-0 bg-black bg-opacity-40"></div>

            {/* Hero Content */}
            <div className="relative z-10 flex flex-col items-center justify-center h-full">
                {/* Main Heading */}
                <div className="text-center mb-12 max-w-4xl">
                    <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
                        Find Your Perfect
                        <span className="block text-blue-400">Career Match</span>
                    </h1>
                    <p className="text-lg sm:text-xl text-gray-200 mb-8 max-w-2xl mx-auto">
                        Connect top talent with leading companies. Whether you're hiring or job seeking, we make the perfect match.
                    </p>
                </div>

                {/* Action Buttons */}
                <div className="flex  flex-col sm:flex-row px-10 md:px-0 gap-6 w-full max-w-2xl">
                    <button 
                        className="group flex-1 bg-blue-600 hover:bg-blue-700 text-white flex items-center justify-center gap-3 py-4 px-8 rounded-xl font-semibold text-lg transition-all duration-300 transform hover:scale-105 hover:shadow-2xl"
                        onClick={() => handlerhire('hiretalent')}
                    >
                        <Handshake size={28} className="group-hover:rotate-12 transition-transform duration-300" />
                        <span>Find Top Talent</span>
                    </button>
                    
                    <button 
                        className="group flex-1 bg-green-600 hover:bg-green-700 text-white flex items-center justify-center gap-3 py-4 px-8 rounded-xl font-semibold text-lg transition-all duration-300 transform hover:scale-105 hover:shadow-2xl"
                        onClick={() => handlerhire('findajob')}
                    >
                        <UserRound size={28} className="group-hover:bounce transition-transform duration-300" />
                        <span>Start Your Career</span>
                    </button>
                </div>

                {/* Image Indicators */}
                <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-3">
                    {images.map((_, index) => (
                        <button
                            key={index}
                            className={`w-3 h-3 rounded-full transition-all duration-300 ${
                                index === currentimage 
                                    ? 'bg-white scale-125' 
                                    : 'bg-white bg-opacity-50 hover:bg-opacity-75'
                            }`}
                            onClick={() => setCurrentImage(index)}
                        />
                    ))}
                </div>
            </div>

            {/* Popup Modal */}
            {hireopen && <HireTalent handlerhire={handlerhire} value={fromtype} />}
        </section>
    )
}
